export class KycSearchRequest {
  aadhaarNumber: string;
  address1: string;
  address2: string;
  address3: string;
  address4: string;
  appId: string;
  appKey: string;
  appName: string = "";
  city: string;
  ckycNo: string;
  country: string;
  createdBy: string;
  createdDate: string;
  customerName: string;
  customerType: string = "";
  district: string;
  dob_doi: string;
  drivingLicense: string;
  eiaNumber: string;
  emailId: string;
  firstName: string;
  gender: string;
  id: number;
  inwardNo: string;
  kycVerifiedDateTime: string;
  lastName: string;
  lob: string;
  middleName: string;
  mobileNo: string;
  panNumber: string;
  passportNumber: string;
  pinCode: string;
  policyNo: string;
  product: string;
  proposalNo: string;
  quoteNo: string;
  returnURL: string;
  state: string;
  token: string;
  uniqueId: string;
  userName: string;
  voterId: string;
  searchType: string;
}

export class TokenRequest {
  appId: string;
  appKey: string;
  customerName: string;
  dob: string;
  redirectedUrl: string;
  token: string;
}

export class TokenResponse {
  token: string;
  errorMsg: any;
}

export class KycSearchResponse {
  returnURL: string;
  url: string;
  kycRefNo: string;
  uniqueId: string;
  kycDetails: KycDetails;
  apiStatus: boolean;
  kycStatus: boolean;
  errMsg: any;
  errorCode: any;
  applicationStatus: string;
}

export class KycDetails {
  ckycNo: any;
  firstName: any;
  middleName: any;
  lastName: any;
  dateOfBirth: any;
  address1: any;
  address2: any;
  address3: any;
  city: any;
  district: any;
  state: any;
  country: any;
  pinCode: any;
  aadhaar: any;
  panNumber: any;
  kycVerifiedDateTime: string;
  gender: any;
}

export class KycResultResponse {
  applicationStatus: string;
  kycRefNo: string;
  uniqueId: string;
  dob: string;
  errMessage?: any;
  returnURL?: any;
  firstName: string;
  middleName?: any;
  lastName: string;
  address1: string;
  address2: string;
  address3: string;
  city: string;
  district: string;
  state: string;
  country: string;
  pinCode: string;
  gender: string;
  fullName: string;
  mobile: string;
  email: string;
  pan: string;
  aadhaar?: any;
  kyc_verified_date: string;
  customerType: string;
  companyName: string;
  gstin?: any;
  cin?: any;
  ckycNo: string;
  status: string;
  companyAddress: string;
  doi: string;
}

export class MasterAppList {
  key: string;
  value: string;
}

export class MasterAppData {
  masterAppList: MasterAppList[] = [];
}
